import { type ComponentProps, type FC } from 'react';

export const IberiaUser: FC<ComponentProps<'svg'>> = (props) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0_2384_4809" maskUnits="userSpaceOnUse" x="2" y="3" width="20" height="20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9081 7.98799C15.9081 11.0154 14.9951 12.976 12.0061 12.976C9.01717 12.976 8.10415 11.0154 8.10415 7.98799C8.10415 4.9606 9.01717 3 12.0061 3C14.9951 3 15.9081 4.9606 15.9081 7.98799ZM12.0047 14.5906C14.9841 14.5906 18.9822 15.1961 20.2604 15.8881L20.2892 15.9169C20.962 18.1562 21.529 20.6166 21.9999 22.9808H1.99994C2.47087 20.6166 3.0379 18.1562 3.71065 15.9169C5.00811 15.2057 8.96774 14.5906 12.0047 14.5906Z"
        fill="#FFFFFF"
      />
    </mask>
    <g mask="url(#mask0_2384_4809)">
      <rect width="23.8528" height="25.0304" fill={props.fill} />
    </g>
  </svg>
);
